import { z } from 'zod';

export const appCheckTokenStatusSchema = z.object({
  status: z.enum(['valid', 'invalid']),
});
